import { useTranslation } from 'react-i18next';
import { Grid } from '@shared/ui';

import { SectionHeader } from './SectionHeader';
import { AlertShowcase } from './feedback/AlertShowcase';
import { BadgeShowcase } from './feedback/BadgeShowcase';
import { TrendIndicatorShowcase } from './feedback/TrendIndicatorShowcase';
import { LoadingShowcase } from './feedback/LoadingShowcase';
import { SpinnerShowcase } from './feedback/SpinnerShowcase';
import { ToastShowcase } from './feedback/ToastShowcase';

export function FeedbackSection() {
  const { t } = useTranslation();

  return (
    <section id="feedback" className="space-y-6">
      <SectionHeader
        title={t('uiLibrary.feedback.title')}
        description={t('uiLibrary.feedback.description')}
      />

      <Grid cols={1} gap="lg" className="lg:grid-cols-2">
        <AlertShowcase />
        <BadgeShowcase />
        <TrendIndicatorShowcase />
        <ToastShowcase />
        <LoadingShowcase />
        <div className="lg:col-span-2">
          <SpinnerShowcase />
        </div>
      </Grid>
    </section>
  );
}
